import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAssociateSaleSetup } from '../actions/associatesActions';
import AssociateRealtime from '../context/AssociateRealtimeProvider';

export default function useRealtimeVerification() {
  const { connection } = useContext(AssociateRealtime);
  const jwt = useSelector(state => state.associates.jwt);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!connection) return;

    const handler = () => {
      dispatch(getAssociateSaleSetup(jwt));
    };

    connection.on('RefreshSaleSetup', handler);

    return () => {
      connection.off('RefreshSaleSetup', handler);
    };
  }, [connection, dispatch, jwt]);
}
